export default __webpack_public_path__ + "static/bg-home-bab3aa0da44b162192839475ebd7809b.png";